/** Options for initializing the PersistenceConfig. */
export interface PersistenceConfigOptions {
    isLoggedIn: () => boolean;
}

/**
 * Static configuration class that decouples persistence infrastructure
 * from app-state by accepting an isLoggedIn callback at bootstrap time.
 */
export class PersistenceConfig {

    private static _isLoggedInFn: (() => boolean) | null = null;

    /**
     * Initializes the persistence configuration with app-state callbacks.
     * Must be called before any other PersistenceConfig method.
     */
    public static initialize(options: PersistenceConfigOptions): void {
        PersistenceConfig._isLoggedInFn = options.isLoggedIn;
    }

    /**
     * Returns whether the current user is logged in.
     * @throws Error if initialize() has not been called yet.
     */
    public static isLoggedIn(): boolean {
        if (PersistenceConfig._isLoggedInFn === null) {
            throw new Error('PersistenceConfig not initialized. Call PersistenceConfig.initialize() before use.');
        }
        return PersistenceConfig._isLoggedInFn();
    }

    /**
     * Resets the configuration to uninitialized state.
     * Intended for use in tests only.
     */
    public static reset(): void {
        PersistenceConfig._isLoggedInFn = null;
    }
}
